import * as React from "react";
import styles from "./ProductsFlexWrapper.module.scss";
import classnames from "classnames";
import { shouldBeThreeProductRows, shouldBeTwoProductRows } from "~/cores/productCore";

export function ProductFlexItemWrapper({ children, newRow }) {
    return (
        <div className={styles["item-wrapper"]} style={{ gridColumn: newRow ? "1 / -1" : "auto" }}>
            {children}
        </div>
    );
}

export function ProductFlexBreak() {
    return <div style={{ flexBasis: "100%" }} />;
}

export default function ProductsFlexWrapper(props) {
    const { children, productsComponents } = props;
    return (
        <div className={styles["container-outer"]}>
            <section
                className={classnames(
                    styles["container"],
                    shouldBeTwoProductRows(productsComponents) && styles["container-2-items"],
                    shouldBeThreeProductRows(productsComponents) && styles["container-3-items"],
                )}
            >
                {productsComponents}
                {children}
            </section>
        </div>
    );
}
